const UserPasswordUrls = {
    FORGOT_PASSWORD: `${process.env.REACT_APP_USER_ACI_SHARED_URL}/shared/user-password/forgotPassword`,
  };
  
  export default UserPasswordUrls